//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoSnackbarDefault from './demos/DemoSnackbarDefault.vue'
import DemoSnackbarWithAction from './demos/DemoSnackbarWithAction.vue'
import DemoSnackbarMultiline from './demos/DemoSnackbarMultiline.vue'
import DemoSnackbarTimeout from './demos/DemoSnackbarTimeout.vue'
import DemoSnackbarVariants from './demos/DemoSnackbarVariants.vue'
import DemoSnackbarVertical from './demos/DemoSnackbarVertical.vue'
import DemoSnackbarPosition from './demos/DemoSnackbarPosition.vue'
import DemoSnackbarTransition from './demos/DemoSnackbarTransition.vue'

// code
import {
  snackbarDefault,
  snackbarWithAction,
  snackbarMultiline,
  snackbarTimeout,
  snackbarVariants,
  snackbarVertical,
  snackbarPosition,
  snackbarTransition,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoSnackbarDefault,
    DemoSnackbarWithAction,
    DemoSnackbarMultiline,
    DemoSnackbarTimeout,
    DemoSnackbarVariants,
    DemoSnackbarVertical,
    DemoSnackbarPosition,
    DemoSnackbarTransition,
  },
  setup() {
    return {
      codeSnippets: {
        snackbarDefault,
        snackbarWithAction,
        snackbarMultiline,
        snackbarTimeout,
        snackbarVariants,
        snackbarVertical,
        snackbarPosition,
        snackbarTransition,
      },
    }
  },
}
